// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { useEntity } from '../helpers/selectors'
import { connect } from 'react-redux'
import { getESProductDataSetData } from '../../redux/elasticsearch/elasticsearch-selectors'
import { FsCore } from '../../types/fs-core'
import { ProvidersLogoModule } from './providers-logo-module-legacy'
import ProviderLogoPlatinum from '../platinum-modules/provider-logo'
interface ProviderLogo {
  id: string
  name: string
  images: {
    money: string
    uswitch: string
  }
}

interface ProvidersLogoModuleProps {
  name: string
  heading: any
  dataset: object
  orderOverride: object[]
  clickable: boolean
  providerLogoData: FsCore.ESHit[] | undefined
  variant: string
}

const ProvidersLogoModuleWrapper: React.FC<ProvidersLogoModuleProps> = ({
  heading,
  dataset,
  orderOverride,
  clickable = false,
  providerLogoData,
  variant,
  name,
}) => {
  const { data: providers, query } = useEntity(dataset)

  let providerLogos: ProviderLogo[] = providers

  if (providerLogoData && query) {
    const logoData = providerLogoData.map((p) => {
      const { provider } = p._source.definition
      return {
        id: provider.id,
        name: provider.name,
        images: {
          money: provider.logo.money,
          uswitch: provider.logo.uswitch,
        },
      }
    })
    // get all unique logos
    const uniqueLogos = Array.from(new Set(logoData.map((a) => a.id))).map((id) => {
      return logoData.find((a) => a.id === id)
    }) as ProviderLogo[]
    providerLogos = uniqueLogos
  }

  if (variant === 'platinum' || variant === 'cardFinderProviders' || variant === 'bordered') {
    return (
      <ProviderLogoPlatinum
        provider={providerLogos}
        orderOverride={orderOverride}
        name={name}
        variant={variant}
        heading={heading}
      />
    )
  }

  return (
    <ProvidersLogoModule
      providers={providerLogos}
      heading={heading}
      orderOverride={orderOverride}
      clickable={clickable}
    />
  )
}

export default connect((state: FsCore.State, props) => {
  const providerLogoData = getESProductDataSetData(state, props.dataset.sys.id)?.hits?.hits
  return {
    ...props,
    providerLogoData,
  }
})(ProvidersLogoModuleWrapper)
